import { ContentObject, SupportedEmbeddingTypes } from "@vertesia/common"
import { FileSearchIcon, FolderSearchIcon, TextSearchIcon } from "lucide-react"

import { Button } from "@ui/button"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@ui/tooltip"

interface EmbeddingsTypeButtonGroupProps {
    document: ContentObject
    type?: SupportedEmbeddingTypes
    onUpdate: (type: SupportedEmbeddingTypes | undefined) => void
}
export function EmbeddingsTypeButtonGroup({ document, type, onUpdate }: Readonly<EmbeddingsTypeButtonGroupProps>) {
    const handleOnClick = (embeddingType: SupportedEmbeddingTypes) => {
        onUpdate(embeddingType)
    }

    return (
        <div className="flex gap-2">
            <TooltipProvider>
                {document.embeddings.text && (
                    <Tooltip>
                        <TooltipTrigger asChild className="text-primary">
                            <Button variant="outline" size="icon" onClick={() => handleOnClick(SupportedEmbeddingTypes.text)} className={`${type === SupportedEmbeddingTypes.text ? "bg-gray-200 text-primary-contrast" : "text-primary hover:bg-gray-200"} hover:opacity-75`}>
                                <TextSearchIcon className="h-5 w-5" />
                            </Button>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>Text embeddings search</p>
                        </TooltipContent>
                    </Tooltip>
                )}
                {document.embeddings.image && (
                    <Tooltip>
                        <TooltipTrigger asChild className="text-primary">
                            <Button variant="outline" size="icon" onClick={() => handleOnClick(SupportedEmbeddingTypes.image)} className={`${type === SupportedEmbeddingTypes.image ? "bg-gray-200 text-primary-contrast" : "text-primary hover:bg-gray-200"} hover:opacity-75`}>
                                <FolderSearchIcon className="h-5 w-5" />
                            </Button>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>Image embeddings search</p>
                        </TooltipContent>
                    </Tooltip>
                )}
                {document.embeddings.properties && (
                    <Tooltip>
                        <TooltipTrigger asChild className="text-primary">
                            <Button variant="outline" size="icon" onClick={() => handleOnClick(SupportedEmbeddingTypes.properties)} className={`${type === SupportedEmbeddingTypes.properties ? "bg-gray-400 text-primary-contrast hover:bg-gray-400" : "text-primary"} hover:opacity-75`}>
                                <FileSearchIcon className="h-5 w-5" />
                            </Button>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>Properties embeddings search</p>
                        </TooltipContent>
                    </Tooltip>
                )}
            </TooltipProvider>
        </div>
    )
}
